import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const commonFormikPropTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/propTypes/formik.js